<script setup lang="ts">
import type { FieldDef } from "./fieldRegistry";
import { toneChipStyle, type LayerTone } from "./layerTone";

const props = withDefaults(defineProps<{
  available: readonly FieldDef[];
  tone?: LayerTone;
  label?: string;
}>(), {
  tone: "link",
  label: "Set another field",
});

const emit = defineEmits<{
  pick: [field: FieldDef];
}>();

const open = shallowRef(false);

function pick(field: FieldDef) {
  emit("pick", field);
  open.value = false;
}
</script>

<template>
  <Popover v-model:open="open">
    <PopoverTrigger as-child>
      <Button
        type="button"
        variant="outline"
        class="h-[28px] w-full justify-center rounded-md border-dashed text-[10.5px] font-semibold"
        :style="toneChipStyle(tone)"
        :disabled="!available.length"
      >
        <Icon mode="svg" size="12" name="lucide:plus" class="mr-1" />
        {{ label }}
      </Button>
    </PopoverTrigger>
    <PopoverContent align="start" class="w-[320px] p-1.5">
      <div v-if="!available.length" class="p-3 text-center text-[11px] text-muted-foreground">
        Every field is already set.
      </div>
      <div v-else class="grid grid-cols-2 gap-1">
        <button
          v-for="field in available"
          :key="field.key"
          type="button"
          class="rounded-md border px-2 py-2 text-left text-[11.5px] font-medium hover:bg-accent"
          @click="pick(field)"
        >
          {{ field.label }}
        </button>
      </div>
    </PopoverContent>
  </Popover>
</template>
